export const iconAdd = 'add'; // Add item in list, e.g. Add quick reply under http://localhost:8080/conversational/start
export const iconRemove = 'remove'; // Remove item in list, "
export const iconDelete = 'delete'; // Delete something completely that is not part of a list, also for buttons and dropdown menues

export default {
  iconAdd,
  iconRemove,
  iconDelete,
};
